import { Box } from "@material-ui/core";
import NoItemIcon from "../../assets/icons/NoItemIcon";

const NoItemsFound = () => (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%" 
    >
      <div className="no-items-found">
        <NoItemIcon />
        <h2>No items found</h2>
      </div>
    </Box>
  );

export default NoItemsFound;